export var ProductTag;
(function (ProductTag) {
    ProductTag.TagTypeEnum = {
        HasBonusPoints: 'HasBonusPoints',
        IsClubPrice: 'IsClubPrice',
        IsSpecial: 'IsSpecial',
        IsNew: 'IsNew',
        IsMultiBuy: 'IsMultiBuy',
        IsGreatPrice: 'IsGreatPrice',
        IsGreatPriceMultiBuy: 'IsGreatPriceMultiBuy',
        Other: 'Other',
        IsTargetedOffer: 'IsTargetedOffer',
        IsSampled: 'IsSampled',
        IsFreeSample: 'IsFreeSample',
        IsOnlineOnly: 'IsOnlineOnly',
        IsFreshDeal: 'IsFreshDeal',
        IsBoostOffer: 'IsBoostOffer'
    };
})(ProductTag || (ProductTag = {}));
